module.exports = __webpack_public_path__ + "img/angle_270.3baa7827.jpg";